import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { createMachine } from '../../store/slices/machinesSlice';
import { MachineForm, MachineFormValues } from '../../components/machines/MachineForm';

const initialValues: MachineFormValues = {
  name: '',
  description: '',
  location: '',
  status: 'active',
};

export const MachineCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isCreating, error } = useAppSelector((state) => state.machines);

  const handleCancel = () => {
    navigate('/machines');
  };

  const handleSubmit = async (values: MachineFormValues) => {
    try {
      const result = await dispatch(createMachine(values)).unwrap();
      navigate(`/machines/${result.id}`);
    } catch (submitError) {
      console.error('Failed to create machine:', submitError);
    }
  };

  return (
    <>
      <Breadcrumbs sx={{ mb: 2, px: { xs: 2, md: 3 } }} separator="›">
        <Link
          color="inherit"
          href="/"
          onClick={(event) => {
            event.preventDefault();
            navigate('/');
          }}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Startseite
        </Link>
        <Link
          color="inherit"
          href="/machines"
          onClick={(event) => {
            event.preventDefault();
            navigate('/machines');
          }}
        >
          Maschinen
        </Link>
        <Typography color="text.primary">Neue Maschine</Typography>
      </Breadcrumbs>

      <MachineForm
        title="Neue Maschine anlegen"
        initialValues={initialValues}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isSubmitting={isCreating}
        submitLabel="Maschine anlegen"
        error={error}
      />
    </>
  );
};
